import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface authState {
  otpUserData: any;
  otpVerifyUsersData: any;
  userProfile: any;
  passwordType: String | null;
  password: String | null;
  token: any;
  authStatus: boolean;
  permission: any;
  businessType: Array<object> | null;
  loanCategory: Object | null;
  trackingId: string;
  requestSignature: string | null;
}

const initialState: authState = {
  otpUserData: null,
  otpVerifyUsersData: null,
  userProfile: null,
  passwordType: null,
  password: null,
  token: null,
  authStatus: false,
  permission: null,
  businessType: null,
  loanCategory: null,
  trackingId: "",
  requestSignature: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setOtpUserData(state, action) {
      state.otpUserData = action.payload;
    },
    setOtpVerifyUsersData(state, action) {
      state.otpVerifyUsersData = action.payload;
    },
    setUserProfileData(state, action) {
      state.userProfile = action.payload;
    },
    setPasswordType(state, action) {
      state.passwordType = action.payload;
    },
    setPassword(state, action) {
      state.password = action.payload;
    },
    setUserAuth(state, action) {
      state.token = action.payload;
      state.authStatus = !!action.payload;
      // Sync with sessionStorage for consistency
      if (action.payload) {
        sessionStorage.setItem('token', action.payload);
      } else {
        sessionStorage.removeItem('token');
      }
    },
    setUserPermission(state, action) {
      state.permission = action.payload;
    },
    setUserBusinessType(state, action) {
      state.businessType = action.payload;
    },
    setUserLoanCategory(state, action) {
      state.loanCategory = action.payload;
    },
    setTrackingId(state, action) {
      state.trackingId = action.payload;
    },
    setRequestSignature(state, action) {
      state.requestSignature = action.payload;
    },
    clearOtpUserData(state) {
      state.otpUserData = null;
      state.otpVerifyUsersData = null;
    },
    clearPasswordType(state) {
      state.passwordType = null;
    },
    clearPassword(state) {
      state.password = null;
    },
    clearAuth(state) {
      state.otpUserData = null;
      state.otpVerifyUsersData = null;
      state.userProfile = null;
      state.token = null;
      state.authStatus = false;
      state.permission = null;
      state.businessType = null;
      state.password = null;
      state.loanCategory = null;
      state.requestSignature = null;
      // Clear sessionStorage as well
      sessionStorage.removeItem('token');
    },
    // Initialize auth state from sessionStorage if Redux persist hasn't loaded yet
    initializeFromSessionStorage(state) {
      const sessionToken = sessionStorage.getItem('token');
      if (sessionToken && !state.token) {
        state.token = sessionToken;
        state.authStatus = true;
      }
    },
  },
});

export const {
  setOtpUserData,
  setOtpVerifyUsersData,
  setUserProfileData,
  setUserAuth,
  setPasswordType,
  setPassword,
  setUserPermission,
  setUserBusinessType,
  setUserLoanCategory,
  clearAuth,
  clearOtpUserData,
  clearPasswordType,
  clearPassword,
  initializeFromSessionStorage,
  setTrackingId,
  setRequestSignature,
} = authSlice.actions;
export const authSelector = (state: RootState) => state?.auth;
export const authStatusSelector = (state: RootState) => state?.auth.authStatus;
export const authTokenSelector = (state: RootState) => state?.auth.token;
export const userPermissionSelector = (state: RootState) =>
  state?.auth.permission;
export const userSelector = (state: RootState) => state?.auth.userProfile;
export const userBusinessSelector = (state: RootState) =>
  state?.auth.businessType;
export const userLoanCatSelector = (state: RootState) =>
  state?.auth?.loanCategory;
export default authSlice.reducer;
